import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useEffect, useState, useRef } from "react";
import "./supplier.css"
import { RadioButton } from "primereact/radiobutton";
import { Dropdown } from 'primereact/dropdown';
import * as UsStates from "states-us";
import { Checkbox } from "primereact/checkbox";
import { Country, State, City } from "country-state-city";
import PhoneInput, { isValidPhoneNumber, getCountryCallingCode, parsePhoneNumber } from "react-phone-number-input";
import { Toast } from "primereact/toast";
import { validateEmail } from '../../utilities/utillFunction';
import axios from 'axios';
import { Dialog } from 'primereact/dialog';

const Supplier = () => {
    const [entityType, setEntityType] = useState("");
    const [stateOfIncorportation, setStateOfIncorportation] = useState(null);
    const [checked, setChecked] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);
    const [isSubmitForm, setIsSubmittingForm] = useState(false);
    const toast = useRef(null);
    const [openOtpDialog, setOtpDialog] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false)
    const [welcomeDialog, setWelcomeDialog] = useState(false);

    const [supplierInfo, setSupplierInfo] = useState({
        legalBusinessName: '',
        dbaName: '',
        entityType: '',
        stateOfIncoporation: '',
        ein: '',
        country: '',
        state: '',
        city: '',
        street: '',
        zip: '',
        primaryContactName: '',
        titleRole: '',
        emailAddress: '',
        phoneNumber: '',
        countryCode: ''
    })
    useEffect(() => {
        const allCountries = Country.getAllCountries().map((item) => ({
            name: item.name,
            code: item.isoCode,
            phoneCode: item.phonecode
        }));
        setCountries(allCountries);
    }, []);

    const showError = (summary = "", message) => {
        toast.current.show({
            severity: "error",
            summary: !summary ? "Validation Error" : summary,
            detail: message,
            life: 3000,
        });
    };

    const getCountryCodeFromMob = (mob) => {
        let mobileCountry = parsePhoneNumber(mob);
        if (mobileCountry && mobileCountry.country) {
            return getCountryCallingCode(mobileCountry.country);
        }
        return null;
    };

    const isValidEIN = (val) => /^\d{2}-\d{7}$/.test(val);

    const validateForm = () => {
        let isValid = true;
        if (!supplierInfo?.legalBusinessName.trim()) {
            showError("Supplier Information", "Legal Name of Business is required");
            isValid = false;
            return isValid;
        }
        // if (!supplierInfo?.dbaName.trim()) {
        //     showError("Supplier Information", "Enter DBA/Brand name");
        //     isValid = false;
        //     return isValid;
        // }
        if (!entityType.trim()) {
            showError("Supplier Information", "Select the Entity Type");
            isValid = false;
            return isValid;
        }
        // State of Incorporation validation
        if ((!stateOfIncorportation || !stateOfIncorportation?.name)) {
            showError("Supplier Information", "Select the State of Incorporation");
            return false;
        }

        // EIN validation
        if (!supplierInfo.ein?.trim()) {
            showError("Supplier Information", "Please enter the EIN");
            return false;
        }
        if (supplierInfo.ein.length > 10) {
            showError("Supplier Information", "Max EIN length should be 10 characters");
            return false;
        }
        if (!isValidEIN(supplierInfo.ein)) {
            showError("Supplier Information", "Please enter a valid EIN (format: XX-XXXXXXX)");
            return false;
        }

        if (!supplierInfo.street.trim()) {
            showError("Supplier Information", "Please enter the address");
            isValid = false;
            return isValid;
        }
        if (!supplierInfo.zip.trim()) {
            showError("Supplier Information", "Enter Zip code");
            isValid = false;
            return isValid;
        }
        if (supplierInfo.zip.length > 5) {
            showError("Supplier Information", "Max Zip length should be 5 characters");
            isValid = false;
            return isValid;
        }
        // Country validation
        if (!selectedCountry || !selectedCountry?.name) {
            showError("Supplier Information", "Please select the Country");
            return false;
        }
        // State validation (only after country)
        if (!selectedState || !selectedState?.name) {
            showError("Supplier Information", "Please select the State");
            return false;
        }

        // City validation (only after state)
        if (!selectedCity || !selectedCity?.name) {
            showError("Supplier Information", "Please select the City");
            return false;
        }
        if (!supplierInfo.primaryContactName.trim()) {
            showError("Supplier Information", "Please enter the Primary Contact Name");
            isValid = false;
            return isValid;
        }
        if (!supplierInfo.titleRole.trim()) {
            showError("Supplier Information", "Please enter the Title Role");
            isValid = false;
            return isValid;
        }

        if (!supplierInfo?.emailAddress.trim()) {
            showError("Supplier Information", "Please enter the Email");
            isValid = false;
            return isValid;
        }

        if (!validateEmail(supplierInfo?.emailAddress)) {
            showError("Supplier Information", "Please enter a valid email");
            isValid = false;
            return isValid;
        }

        if (supplierInfo.phoneNumber === undefined || !supplierInfo?.phoneNumber?.trim()) {
            showError("Supplier Information", "Please enter the Phone Number");
            isValid = false;
            return isValid;
        }
        if (!isValidPhoneNumber(supplierInfo?.phoneNumber)) {
            showError("Supplier Information", "Please enter a valid Phone Number");
            isValid = false;
            return isValid;
        }
        if (!getCountryCodeFromMob(supplierInfo?.phoneNumber)) {
            showError("Supplier Information", "Please enter a valid Phone Number");
            isValid = false;
            return isValid;
        }
        return isValid;
    };
    const agreeHandler = (e) => {
        setChecked(e.checked);
    }
    const countrySelectHandler = (e) => {
        setSelectedCountry(e.value);
        const statesData = State.getStatesOfCountry(e.value.code).map((item) => ({
            name: item.name,
            code: item.isoCode
        }));
        setStates(statesData);
        setSelectedState({});
        setCities([]);
    };

    const stateSelectHandler = (e) => {
        setSelectedState(e.value);
        const citiesData = City.getCitiesOfState(selectedCountry.code, e.value.code);
        setCities(citiesData);
        setSelectedCity({});
    };


    const onSubmitHandler = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }
        if (checked === false) {
            showError('Validation Error', 'Please agree to the Imagine Home Terms of Service');
            return;
        }
        setIsSubmittingForm(true)
        const otpRes = await axios.post(process.env.REACT_APP_USERMANAGEMENT_SERVICE_URL + "/user-send-otp", {
            newValue: supplierInfo.phoneNumber, type: "mobile", message: "Your One Time Password for registering as a Supplier on Imagine Home is: {OTP}"
        })

        if (otpRes.data.success === true) {
            setOtpDialog(true)
        }
        setIsSubmittingForm(false)
    }

    const handleVerify = async (otp) => {
        try {
            setOtpVerified(true);
            const response = await axios.post(
                `${process.env.REACT_APP_USERMANAGEMENT_SERVICE_URL}/user-verify-otp`,
                {
                    newValue: supplierInfo.phoneNumber,
                    type: "mobile",
                    otp,
                }
            );

            if (!response.data.success) {
                toast.current.show({
                    severity: "error",
                    summary: "Invalid OTP",
                    detail: response.data.message || "Verification failed",
                    life: 2500,
                });
                return; // ❌ prevent next API call
            }

            toast.current.show({
                severity: "success",
                summary: "OTP Verified",
                detail: "Proceeding...",
                life: 1500,
            });

            // Step 2: Prepare FormData
            const payload = {
                name: supplierInfo.primaryContactName,
                email: supplierInfo.emailAddress,
                countryCode: supplierInfo.countryCode,
                mobile: supplierInfo.phoneNumber,
                ein: supplierInfo.ein,
                brandName: supplierInfo.dbaName || "",
                businessLegalName: supplierInfo.legalBusinessName,
                entityType,
                formationState: stateOfIncorportation.name,
                street: supplierInfo.street,
                city: selectedCity.name,
                country: selectedCountry.name,
                state: selectedState.name,
                zip: supplierInfo.zip
            };

            const formData = new FormData();
            Object.entries(payload).forEach(([key, value]) => {
                formData.append(key, value ?? "");
            });

            // Step 3: Final API: Create Supplier
            const res = await axios.post(
                `${process.env.REACT_APP_TENANT_SERVICE_URL}/create-supplier`,
                formData,
                {
                    headers: {
                        "x-api-key": process.env.REACT_APP_AUTH_API_KEY,
                    }
                }
            );

            if (res.data.responseCode === 200) {
                // toast.current.show({
                //     severity: "success",
                //     summary: "Supplier Created!",
                //     detail: "Supplier information added successfully.",
                //     life: 3000,
                // });
                setOtpDialog(false);
                setWelcomeDialog(true)
            }

        } catch (error) {
            const message =
                error.response?.data?.message ||
                (error.request
                    ? "No server response. Check your network."
                    : error.message);

            showError("Verification Failed", message);
        } finally {
            setOtpVerified(false);
        }
    };


    const handleResendOtp = async () => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_USERMANAGEMENT_SERVICE_URL}/user-send-otp`,
                {
                    newValue: supplierInfo.phoneNumber,
                    type: "mobile",
                    message: "Your One Time Password for registering as a Supplier on Imagine Home is: {OTP}"
                },
            );

            toast.current.show({
                severity: "success",
                summary: "OTP Sent",
                detail: "OTP sent successfully!",
                life: 3000
            });

        } catch (error) {
            toast.current.show({
                severity: "error",
                summary: "Error",
                detail: error.response?.data?.message || "Unable to send OTP",
                life: 3000
            });
        }
    };

    const welcomeMessageHandler = () => {
        setSupplierInfo({
            legalBusinessName: "",
            dbaName: "",
            entityType: "",
            stateOfIncorporation: "",
            ein: "",
            country: "",
            state: "",
            city: "",
            street: "",
            zip: "",
            primaryContactName: "",
            titleRole: "",
            emailAddress: "",
            phoneNumber: "",
            countryCode: "",
        });

        setEntityType("");
        setSelectedCountry(null);
        setSelectedState(null);
        setSelectedCity(null);
        setStateOfIncorportation(null);
        setChecked(false);

        setWelcomeDialog(false);
    };

    const isFilled = (value) => {
        if (value === null || value === undefined) return false;
        if (String(value).trim() === "") return false;
        return true;
    };

    const closeOtpDialogHandler = () => {
        setOtpDialog(false)
        setIsSubmittingForm(false);
    }

    return (
        <>
            <div className="suppplierInfo flex flex-column justify-content-center align-items-center min-h-screen"
                style={{ backgroundColor: '#fbf9f3', padding: '36px 0px' }}
            >
                <Toast ref={toast} />
                <WelcomeDialog
                    visible={welcomeDialog}
                    onHide={welcomeMessageHandler}
                />
                <OTPDialog
                    visible={openOtpDialog}
                    onHide={closeOtpDialogHandler}
                    onVerify={handleVerify}
                    phoneNumber={supplierInfo.phoneNumber}
                    resendOtpHandler={handleResendOtp}
                    isVerifiedOtp={otpVerified}
                />
                <div
                    className="w-11 lg:w-7"
                    style={{ fontFamily: 'Cormorant, serif', fontSize: '36px', color: '#1D1B1C', fontWeight: 500, lineHeight: '49.5px', marginBottom: '22px' }}
                >
                    Suppliers Sign Up
                </div>
                <form onSubmit={onSubmitHandler} className="w-11 lg:w-7">
                    <div className="flex flex-column md:flex-row mb-3" style={{ gap: '10px' }}>
                        <div className={`supplierInfo__input-wrapper w-full ${isFilled(supplierInfo.legalBusinessName) ? 'supplierInfo__input-wrapper-filled' : ''}`}>
                            <span className="p-float-label w-full">
                                <InputText id="legalBusinessName" value={supplierInfo.legalBusinessName} onChange={e => setSupplierInfo(prev => ({ ...prev, legalBusinessName: e.target.value }))} type="text" className="w-full" style={{ border: 'none' }} />
                                <label htmlFor="legalBusinessName">Legal Business Name *</label>
                            </span>
                        </div>
                        <div className={`supplierInfo__input-wrapper w-full ${isFilled(supplierInfo.dbaName) ? 'supplierInfo__input-wrapper-filled' : ''}`}>
                            <span className="p-float-label w-full">
                                <InputText id="brandName" value={supplierInfo.dbaName} onChange={e => setSupplierInfo(prev => ({ ...prev, dbaName: e.target.value }))} type="text" className="w-full" style={{ border: 'none' }} />
                                <label htmlFor="brandName" >DBA / Brand Name</label>
                            </span>
                        </div>
                    </div>

                    <div className="mb-3">
                        <div className={`supplierInfo__input-wrapper shadow-2 w-full overflow-hidden px-3 `}>
                            <label className="entity-type_label">Entity Type *</label>
                            <div className="flex align-items-center">
                                {
                                    <div className="flex flex-column sm:flex-row">
                                        {['Corporation', 'LLC', 'Partnership', 'Sole Proprietor'].map((item, index) => (
                                            <div className="flex align-items-center m-2 md:mx-2" key={item}>
                                                <RadioButton
                                                    inputId={`entity-${index}`}
                                                    name="entityType"
                                                    value={item}
                                                    checked={entityType === item}
                                                    onChange={(e) => setEntityType(e.value)}
                                                    style={{ transform: "scale(0.6)" }}
                                                />
                                                <label className="mx-1" htmlFor={`entity-${index}`}>
                                                    {item}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                }
                            </div>
                        </div>

                    </div>

                    <div className={`supplierInfo__input-wrapper mb-3 w-full ${isFilled(stateOfIncorportation) ? 'supplierInfo__input-wrapper-filled' : ''}`}>
                        <span className="p-float-label -mx-1">
                            <Dropdown
                                value={stateOfIncorportation}
                                onChange={(e) => setStateOfIncorportation(e.value)}
                                options={UsStates?.states}
                                optionLabel="name"
                                className="w-full"
                                checkmark
                                highlightOnSelect={false}
                                id='stateOfIncorportation'
                            />
                            <label className='' htmlFor="stateOfIncorportation">State of Incorporation / Formation *</label>
                        </span>
                    </div>


                    <div className={`supplierInfo__input-wrapper w-full mb-3 ${isFilled(supplierInfo.ein) ? 'supplierInfo__input-wrapper-filled' : ''}`}>
                        <span className="p-float-label w-full">
                            <InputText id="ein" type="text" value={supplierInfo?.ein} onChange={e => setSupplierInfo(prev => ({ ...prev, ein: e.target.value }))} className="w-full" style={{ border: 'none' }} />
                            <label htmlFor="ein">EIN / Tax ID Number *</label>
                        </span>
                    </div>

                    <div className="flex flex-column md:flex-row mb-3" style={{ gap: '10px' }}>
                        <div className={`supplierInfo__input-wrapper w-full ${isFilled(supplierInfo.street) ? 'supplierInfo__input-wrapper-filled' : ''}`}>
                            <span className="p-float-label w-full">
                                <InputText id="street" type="text" value={supplierInfo.street} onChange={e => setSupplierInfo(prev => ({ ...prev, street: e.target.value }))} className="w-full" style={{ border: 'none' }} />
                                <label htmlFor="street" >Address *</label>
                            </span>
                        </div>
                        <div className={`supplierInfo__input-wrapper w-full ${!isFilled(supplierInfo.zip) ? '' : 'supplierInfo__input-wrapper-filled'}`}>
                            <span className="p-float-label w-full">
                                <InputText value={supplierInfo.zip} onChange={e => setSupplierInfo(prev => ({ ...prev, zip: e.target.value }))} id="zip" type="text" className="w-full" style={{ border: 'none' }} />
                                <label htmlFor="zip">Zip *</label>
                            </span>
                        </div>
                    </div>

                    <div className="flex flex-column md:flex-row mb-3" style={{ gap: '10px' }}>
                        <div className={`supplierInfo__input-wrapper w-full ${isFilled(selectedCountry) ? 'supplierInfo__input-wrapper-filled' : ''}`}>
                            <span className="p-float-label -mx-1">
                                <Dropdown
                                    id="country"
                                    value={selectedCountry}
                                    onChange={(e) => countrySelectHandler(e)}
                                    options={countries}
                                    optionLabel="name"
                                    className="w-full"
                                    checkmark
                                    highlightOnSelect={false}
                                    filter
                                />
                                <label className='' htmlFor="country">Country *</label>
                            </span>
                        </div>

                        <div className={`supplierInfo__input-wrapper w-full ${isFilled(selectedState) ? 'supplierInfo__input-wrapper-filled' : ''}`}>
                            <span className="p-float-label -mx-1">
                                <Dropdown
                                    id="state"
                                    value={selectedState}
                                    onChange={(e) => stateSelectHandler(e)}
                                    options={states}
                                    optionLabel="name"
                                    className="w-full my-2"
                                    checkmark
                                    highlightOnSelect={false}
                                    filter
                                />
                                <label className='' htmlFor="state">State *</label>
                            </span>
                        </div>
                        <div className={`supplierInfo__input-wrapper w-full ${isFilled(selectedCity) ? 'supplierInfo__input-wrapper-filled' : ''}`}>
                            <span className="p-float-label -mx-1">
                                <Dropdown
                                    id="city"
                                    value={selectedCity}
                                    onChange={(e) => setSelectedCity(e.value)}
                                    options={cities}
                                    optionLabel="name"
                                    className="w-full"
                                    checkmark
                                    highlightOnSelect={false}
                                    filter
                                />
                                <label className='' htmlFor="city">City *</label>
                            </span>
                        </div>
                    </div>

                    <div className={`supplierInfo__input-wrapper w-full mb-3 ${isFilled(supplierInfo.primaryContactName) ? 'supplierInfo__input-wrapper-filled' : ''}`}>
                        <span className="p-float-label w-full">
                            <InputText id="primaryContactName" type="text" className="w-full" style={{ border: 'none' }} value={supplierInfo.primaryContactName} onChange={e => setSupplierInfo(prev => ({ ...prev, primaryContactName: e.target.value }))} />
                            <label htmlFor="primaryContactName" >Primary Contact Name *</label>
                        </span>
                    </div>
                    <div className={`supplierInfo__input-wrapper w-full mb-3 ${isFilled(supplierInfo.titleRole) ? 'supplierInfo__input-wrapper-filled' : ''}`}>
                        <span className="p-float-label w-full">
                            <InputText value={supplierInfo.titleRole} onChange={e => setSupplierInfo(prev => ({ ...prev, titleRole: e.target.value }))} id="titleRole" type="text" className="w-full" style={{ border: 'none' }} />
                            <label htmlFor="titleRole" >Title Role *</label>
                        </span>
                    </div>

                    <div className="flex flex-column md:flex-row mb-3" style={{ gap: '10px' }}>
                        <div className={`supplierInfo__input-wrapper w-full ${isFilled(supplierInfo?.emailAddress) ? 'supplierInfo__input-wrapper-filled' : ''}`}>
                            <span className="p-float-label w-full">
                                <InputText id="emailAddress" value={supplierInfo.emailAddress} onChange={e => setSupplierInfo(prev => ({ ...prev, emailAddress: e.target.value }))} type="text" className="w-full" style={{ border: 'none' }} />
                                <label htmlFor="emailAddress" >Email Address *</label>
                            </span>
                        </div>

                        <div className={`supplierInfo__input-wrapper w-full  w-full ${isFilled(supplierInfo.phoneNumber) ? 'supplierInfo__input-wrapper-filled' : ''}`}>
                            <span className="p-float-label">
                                <PhoneInput
                                    id="mobNumber"
                                    className="p-inputtext p-component w-full"
                                    inputClassName="w-full"
                                    value={supplierInfo?.phoneNumber}
                                    onChange={(value) => { setSupplierInfo((prev) => ({ ...prev, phoneNumber: value, })); }}
                                    international
                                    onCountryChange={(country) => {
                                        if (!country) return; // Prevent error
                                        const callingCode = getCountryCallingCode(country);
                                        setSupplierInfo(prev => ({ ...prev, countryCode: callingCode }));
                                    }}
                                />
                                <label htmlFor="mobNumber">Phone Number *</label>
                            </span>
                        </div>

                    </div>

                    <div className="flex justify-content-start my-4 w-full">
                        <div className="flex align-items-center">
                            <Checkbox checked={checked}
                                onChange={(e) => agreeHandler(e)} inputId="tos" />
                            <label htmlFor="tos" className="text-xl ml-3">
                                I agree to Imagine Home{" "}
                                <a href='https://imaginehome-images.s3.us-east-1.amazonaws.com/Supplier_Terms_of_Service.pdf' target='_blank'
                                    className="underline text-blue-600 hover:text-blue-700 cursor-pointer"
                                >
                                    Supplier Accounts Terms of Service
                                </a>
                            </label>
                        </div>
                    </div>

                    <p className='suppplierInfo'>
                        Note: On clicking on Send button, a verification code will be sent to above phone number.
                    </p>

                    <div className="flex justify-content-center md:justify-content-start" style={{ marginTop: '22px' }}>
                        <Button
                            type="submit"
                            label="Send"
                            className="supplier_custom-btn"
                            disabled={isSubmitForm}
                        />
                    </div>
                </form>
            </div>
        </>
    );
};

export default Supplier;



function OTPDialog({ visible, onHide, onVerify, resendOtpHandler, phoneNumber, isVerifiedOtp }) {
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const inputsRef = useRef([]);

    const handleChange = (value, index) => {
        if (!/^\d*$/.test(value)) return;
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < 5) {
            inputsRef.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && index > 0 && !otp[index]) {
            inputsRef.current[index - 1]?.focus();
        }
    };

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            breakpoints={{ '960px': '75vw', '640px': '90vw' }}
            style={{ width: '26rem', background: '#fbf9f3' }}
            contentStyle={{ background: '#fbf9f3', padding: '1.5rem' }}
            showHeader={false}
            className="supplier_custom-dialog"
            draggable={false}
        >
            <div className="flex justify-content-between align-items-center mb-3">
                <h3 style={{ fontFamily: 'Cormorant, serif', color: '#1D1B1C', fontWeight: 500, lineHeight: '49.5px', }}
                    className="m-0">Verify OTP</h3>
                <i
                    className="pi pi-times cursor-pointer"
                    onClick={onHide}
                    style={{ fontSize: "1.2rem" }}
                />
            </div>
            <p className="text-center mb-3 welcomeMessage">
                Enter the 6-digit code sent to <strong>{phoneNumber}</strong>
            </p>

            <div className="flex justify-content-center my-3">
                {otp.map((digit, index) => (
                    <InputText
                        key={index}
                        value={digit}
                        maxLength={1}
                        className="text-center mx-1 suppplierInfo otp_input_supplier"
                        ref={(el) => (inputsRef.current[index] = el)}
                        onChange={(e) => handleChange(e.target.value, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                    />
                ))}
            </div>
            <div className="flex flex-column justify-content-center align-items-center mt-3">
                <Button
                    disabled={isVerifiedOtp || !otp.every((digit) => digit !== "")}
                    label="Verify"
                    onClick={async () => {
                        await onVerify(otp.join(""));
                        setOtp(new Array(6).fill(""));
                    }}
                    className="w-6 md:w-4 mt-3 lg:w-6 suppplierInfo"
                    style={{ background: '#9aab89', border: 'none', borderRadius: '6px' }}
                />
                <Button
                    label="Resend OTP"
                    className="p-button-text suppplierInfo"
                    onClick={resendOtpHandler}
                />
            </div>
        </Dialog>
    );
}

function WelcomeDialog({ visible, onHide }) {
    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            breakpoints={{ '960px': '75vw', '640px': '90vw' }}
            style={{ width: '35vw', background: '#fbf9f3 !important' }}
            contentStyle={{ background: '#fbf9f3', padding: '2rem' }}
            showHeader={false}
            className="supplier_custom-dialog"
            draggable={false}
        >
            <div className="text-center">
                <div
                    className="text-center"
                    style={{ fontFamily: 'Cormorant, serif', fontSize: '36px', color: '#1D1B1C', fontWeight: 500, lineHeight: '49.5px', marginBottom: '22px', letterSpacing: '0.04rem !important' }}
                >
                    Welcome!
                </div>
                <p className="mb-4 welcomeMessage">
                    Your information has been successfully submitted! Someone from Imagine Home will get in touch with you soon.
                </p>
                <Button
                    label="OK"
                    className="supplier_custom-btn"
                    onClick={onHide}
                />
            </div>
        </Dialog>
    );
}
